import { useEffect, useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  fetchSurveyQuestions,
  addSurveyQuestion,
  updateSurveyQuestion,
} from "../../../redux/actions/surveyQuestionActions";
import { fetchProducts } from "../../../redux/actions/productActions";
import { Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { NavContext } from "../../NavContext";

const SurveyQuestionForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeNav, setActiveNav } = useContext(NavContext);
  const [selectedProducts, setSelectedProducts] = useState([]);

  useEffect(() => {
    setActiveNav("surveyQuestions");
  }, [setActiveNav]);

  const { id } = useParams();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const products = useSelector((state) => state.productReducer.products);
  const isFetching = useSelector((state) => state.productReducer.isFetching);
  const isFetchingQuestions = useSelector(
    (state) => state.surveyQuestionReducer.isFetching
  );

  const surveyQuestions = useSelector(
    (state) => state.surveyQuestionReducer.surveyQuestions
  );

  const surveyQuestion = surveyQuestions.find(
    (surveyQuestion) => surveyQuestion._id === id
  );

  useEffect(() => {
    if (!isFetchingQuestions) {
      dispatch(fetchSurveyQuestions());
    }
  }, [dispatch, surveyQuestion, isFetchingQuestions]);

  useEffect(() => {
    if (!isFetching) {
      dispatch(fetchProducts());
    }
    if (surveyQuestion) {
      setSelectedProducts(surveyQuestion.products);
      reset({
        title: surveyQuestion.title,
        responseType: surveyQuestion.responseType,
        products: surveyQuestion.products,
      });
    }
  }, [dispatch, surveyQuestion, reset, isFetching, products]);

  const handleProductAddition = (productId) => {
    const productToAdd = products.find((product) => product._id === productId);
    if (productToAdd && !selectedProducts.some((product) => product._id === productId)) {
      setSelectedProducts((prevProducts) => [...prevProducts, productToAdd]);
    }
  };

  const handleProductRemoval = (productId) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.filter((product) => product._id !== productId)
    );
  };

  const onSubmit = (data) => {
    if (surveyQuestion) {
      dispatch(
        updateSurveyQuestion(surveyQuestion._id, { ...data, products: selectedProducts })
      );
    } else {
      dispatch(addSurveyQuestion({ ...data, products: selectedProducts }));
    }
    navigate("/survey-questions");
    reset();
  };

  const productList = products.map((option) => ({
    value: option._id,
    label: option.name,
  }));

  return (
    <>
      <div className="pb-4">
        <nav aria-label="breadcrumb" className="breadcrumb">
          <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-0 px-0 me-sm-6 me-5">
            <li className="breadcrumb-item text-sm"></li>
            <li className="breadcrumb-item text-sm text-dark " aria-current="page">
              <Link to={`/survey-questions`}>Questions d'enquête</Link>
            </li>
            <li className="breadcrumb-item text-sm text-dark " aria-current="page">
              {surveyQuestion ? "Modification de la question" : " Nouvelle question"}
            </li>
          </ol>
        </nav>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <section>
          <Row>
            <Col className="d-flex flex-column mx-auto">
              <div className="card medium-card mb-4 pb-2 purple-border">
                <div className="card-header text-left">
                  <Col md={6}>
                    {surveyQuestion ? (
                      <h6>
                        <span className="product-title px-3 text-white">
                          Modification de la question : {surveyQuestion.title}
                        </span>
                      </h6>
                    ) : (
                      <h6>
                        <span className="product-title px-3 text-white">
                          Nouvelle question
                        </span>
                      </h6>
                    )}
                  </Col>
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <label htmlFor="title" className="form-label">
                      Titre :
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      {...register("title", { required: true })}
                    />
                    {errors.title && <div className="text-danger">Titre requis</div>}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="responseType" className="form-label">
                      Type de Réponse :
                    </label>
                    <select
                      className="form-control"
                      {...register("responseType", { required: true })}
                    >
                      <option value="text">Texte</option>
                      <option value="scale">Échelle</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="productSelect" className="form-label">
                      Ajouter un produit :
                    </label>
                    <Select
                      options={productList}
                      isClearable={true}
                      placeholder="Sélectionnez un produit"
                      onChange={(e) => handleProductAddition(e.value)}
                    />

                    <ul className="mt-3">
                      {selectedProducts.map((product) => (
                        <li key={product._id} className="d-flex align-items-center">
                          {product.name}
                          <span
                            className="ml-2 cursor-pointer"
                            onClick={() => handleProductRemoval(product._id)}
                          >
                            ✖️
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  {/* You can also map through the questions array and create a dynamic form input for each question */}
                  <div className="">
                    <button type="submit" className="btn bg-gradient-dark w-30 mt-4 mb-0">
                      Enregistrer
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Link to={`/survey-questions`} className="link-action back">
                Retour
              </Link>
            </Col>
          </Row>
        </section>
      </form>
    </>
  );
};

export default SurveyQuestionForm;
